import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { equals, find, lensPath, propEq, set } from "ramda";
import { MediaContext } from "../../common/media-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons";
import { mapIndexed } from "../../../util/ext";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import Typography from "@material-ui/core/Typography";

import SelectableMenuItem from "../../../components/SelectableMenuItem";
import { Link } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },

  button: {
    alignSelf: "flex-start",
  },

  endIcon: {
    color: theme.palette.primary.brandPrimary,
  },
}));

const sortBy = [
  { label: "Alphabetically (A-Z)", value: "title asc" },
  { label: "Alphabetically (Z-A)", value: "title desc" },
  { label: "Author Last Name (A-Z)", value: "contributor.last_name asc" },
  { label: "Author Last Name (Z-A)", value: "contributor.last_name desc" },
  { label: "Publication Date (New - Old)", value: "publicationDate desc" },
  { label: "Publication Date (Old - New)", value: "publicationDate asc" },
  { label: "Last Updated", value: "auditUpdated desc" },
  { label: "Custom", value: "collectionDisplayOrder" },
];

const DefaultContentSort = () => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const [selected, setSelected] = useState({
    label: "Order By",
    value: null,
  });

  useEffect(() => {
    if (context.media.defaultContentSort) {
      setSelected(
        find(propEq("value", context.media.defaultContentSort), sortBy),
      );
    }
  }, [context.media]);

  //-- Manage Menu State
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = event => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleSortSelect = value => {
    context.setMedia(set(lensPath(["defaultContentSort"]), value));
    setAnchorEl(null);
  };
  return (
    <div className={classes.root}>
      <Typography variant="h2" style={{ fontWeight: 700 }}>
        File Order
      </Typography>
      <Typography>
        Set the order for the files within the collection. By doing this, your
        files will be sorted accordingly on Biblioboard Library. By default,
        files will be ordered alphabetically by title. Note: a "custom" file
        order cannot be created in the current version of Creator. If you would
        like a custom order for your files within this collection, please reach
        out to{" "}
        <Link href="mailto:support@biblioboard.com">
          support@biblioboard.com
        </Link>
        .
      </Typography>
      <Button
        onClick={handleClick}
        variant="outlined"
        color="primary"
        endIcon={<FontAwesomeIcon icon={faAngleDown} />}
        classes={{ root: classes.button, endIcon: classes.endIcon }}
      >
        {selected.label}
      </Button>
      <Menu
        id="sort-by-options-for-default-content-sort"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        getContentAnchorEl={null}
      >
        {mapIndexed(
          (opt, idx) => (
            <SelectableMenuItem
              key={idx}
              label={opt.label}
              MenuItemProps={{
                onClick: () => handleSortSelect(opt.value),
                selected: equals(opt.value, selected.value),
              }}
            />
          ),
          sortBy,
        )}
      </Menu>
    </div>
  );
};

export default DefaultContentSort;
